export default "__VITE_ASSET__e6bb69aa__"